import aws from 'services/aws';
const API = aws.API;
export const useChatAuth = () => {
  const apiName = 'sdmVirtualEventModeratorApi';

  const getInvitationInfo = async ({ sessionId, accessToken }) => {
    const input = {
      sessionId,
      accessToken,
    };
    //TODO: cambiare la risposta della lambda con le info sull'invito (prendere l'invitationType per sapere se è vip -> cambiare nome alla lambda)
    const res = await API.lambdaPost(apiName, '/invitationInfo', input);
    const data = res?.message;
    return {
      isInvited: data.isInvited, //sarà da modificare
      invitationType: data.invitationType,
    };
  };

  return { getInvitationInfo };
};
